import { Options, Vue } from 'vue-class-component';
import BadgeItem from '../../BadgeItem/BadgeItem.vue';
import {
  ApartmentDTO,
  BadgeDTO,
  GateGuestDTO,
} from '@/../client-generator/generated-clients/plants';
import { PropType } from 'vue';

@Options({
  name: 'AddBadgePage',
  props: {
    plantBadges: {
      type: Object as PropType<BadgeDTO[]>,
      required: true,
    },
    badgesList: {
      type: Object as PropType<BadgeDTO[]>,
      required: true,
    },
    gateGuest: {
      type: Object as PropType<GateGuestDTO>,
      required: false,
      default: null,
    },
    apartment: {
      type: Object as PropType<ApartmentDTO>,
      required: false,
      default: null,
    },
  },
  components: {
    BadgeItem,
  },
  watch: {
    badgeCode: function (newValue) {
      this.verifyValidityOfCode(newValue);
    },
  },
  emits: ['add-badge', 'remove-badge'],
})
export default class AddBadgePage extends Vue {
  plantBadges!: BadgeDTO[];
  badgesList!: BadgeDTO[];
  apartment!: ApartmentDTO;
  gateGuest!: GateGuestDTO;
  badgeCode: string = '';
  isValidCode = true;
  invalidCodeReason = '';

  get addButtonDisabled() {
    const codeNotValid = !this.isValidCode || !this.badgeCode?.trim();
    if (this.gateGuest) {
      const guestHasAlreadyBadge = this.badgesList.some(
        (badge) => badge.gateGuest?.id === this.gateGuest.id
      );
      return codeNotValid || guestHasAlreadyBadge;
    }
    return codeNotValid;
  }

  get noBadgeText() {
    const textToSplit = this.$t('AppResourceEP.BadgesListEmptyMessage');
    const noBadgeTextLines = textToSplit.split('\n');
    return noBadgeTextLines;
  }

  addBadge() {
    const addedBadge: BadgeDTO = new BadgeDTO({
      badgeCode: this.badgeCode,
      gateGuest: this.gateGuest,
      apartment: this.apartment,
    });
    this.$emit('add-badge', addedBadge);
    this.badgeCode = '';
  }

  removeBadge(badgeToRemove: BadgeDTO) {
    this.$emit('remove-badge', badgeToRemove);
  }

  async verifyValidityOfCode(codeToCheck: string) {
    this.badgeCode = codeToCheck.trim();

    const alreadyExisting = this.plantBadges.some(
      (plantBadge) =>
        plantBadge.badgeCode?.toLowerCase().trim() ===
        this.badgeCode?.toLowerCase().trim()
    );

    const alreadyAdded = this.badgesList.some(
      (addedBadge) =>
        addedBadge.badgeCode?.toLowerCase().trim() ===
        this.badgeCode?.toLowerCase().trim()
    );

    this.isValidCode = !alreadyExisting && !alreadyAdded;
    this.invalidCodeReason = this.isValidCode
      ? ''
      : this.$t('general.alreadyExisting');
  }
}
